import React from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import MyPatientDetail from './MyPatientDetail';
import MyPatientsHome from './MyPatientsHome';
import { myPatientPath, myPatientsListPath } from '../utils/myPatients';

function MyPatientTabRedirect() {
  const { patientId } = useParams();
  return <Navigate to={myPatientPath(patientId, 'personal')} replace />;
}

const MyPatients = () => (
  <Routes>
    <Route index element={<MyPatientsHome />} />
    <Route path=":patientId" element={<MyPatientTabRedirect />} />
    <Route path=":patientId/:tab" element={<MyPatientDetail />} />
    <Route path="*" element={<Navigate to={myPatientsListPath()} replace />} />
  </Routes>
);

export default MyPatients;
